import { Component, OnInit, Output, EventEmitter, Injector, OnDestroy } from '@angular/core';
import { Constant } from '../../constant';
import {MenuService} from "../../../common/service/menu.service";
import { Route, Router } from '@angular/router';
import { UserService } from '../../service/user.service';
import { Subscription } from 'rxjs';
import { UserProfile } from '../../models/users.model';
import { EventManagerService } from '../../service/event-manager.service';
import { AppQueries } from 'src/app/state';
import { AccountService } from 'src/app/main/services/account.service';
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
    selector: 'fmarket-issuer-navbar',
    templateUrl: './navbar-issuer.component.html',
    styleUrls: [
        'navbar.scss'
    ]
})
export class NavbarIssuerComponent implements OnInit, OnDestroy {
    categories: any;
    category: String;
    total: any;
    public Constant = Constant;
    PRODUCT = 'PRODUCTS';
    CREATE = 'CREATE';
    TRANSACTION_MANAGEMENT = 'TRANSACTION-MANAGEMENT';
    MONEY_TRANSACTION = 'MONEY-TRANSACTION';
    REPORT = 'REPORT';
    AGENCY = 'AGENCY';
    PROFILE = 'USER-DOC';
    accountNumber: String;
    userType: string;
    issuerType: string;
    isFundManagement: boolean = false;
    subscriptions?: Subscription[] = [];
    user: UserProfile = new UserProfile();
    constructor(
        private accountService: AccountService,
        public menuService:MenuService,
        private router: Router,
        private userService: UserService,
        private eventManager: EventManagerService,
        private appQueries: AppQueries,
    ) {

    }
    ngOnInit() {
        this.subscriptions.push(
            this.appQueries.userProfile$
            .subscribe((userProfile) => {
                if (!userProfile) {
                    return;
                }
              this.user = userProfile;
              this.issuerType = (this.user.issuerType || {}).code;;
              this.accountNumber = this.user.code;
              this.userType = this.user.userType;
              if (this.user.issuerType && this.user.issuerType.code === Constant.FUND_ISSUER) {
                  $('.create-fund').show();
                  $('.create-bond').hide();
                  $('.create-cd').hide();
              }  else if (this.user.issuerType && this.user.issuerType.code === Constant.BOND_ISSUER) {
                  $('.create-bond').show();
                  $('.create-fund').hide();
                  $('.create-cd').hide();
              }  else if (this.user.issuerType && this.user.issuerType.code === Constant.BOND_FUND_ISSUER) {
                  $('.create-bond').show();
                  $('.create-fund').show();
                  $('.create-cd').hide();
              }  else if (this.user.issuerType && this.user.issuerType.code === Constant.CERTIFICATE_OF_DEPOSIT_ISSUER) {
                  $('.create-bond').hide();
                  $('.create-fund').hide();
                  $('.create-cd').show();
              }  
            })
        );
        this.userService.subProfile()
            .then((res: any) => {
                if (res) {
                   
                }
        })
        
        this.category = this.PRODUCT;
        this.router.events.subscribe((event: any) => {
            if (event && event.url) {
                const array = event.url.split('/');
                const destination = array[array.length - 1].split('-');
                this.category = destination[0].toUpperCase();
            }
        });
        $(document).ready(() => {
            $('.navbar-issuer .navbar-toggler').on('click', function() {
              $('.navbar-issuer').toggleClass('active');
            });
          })
    }
    ngOnDestroy() {
        this.eventManager.destroys(this.subscriptions);
    }
    changeCategory(value) {
        this.category = value;
    }
    signOut() {
        // this.loading.showLoading();
        this.accountService.logout()
      }
}
